import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navigation from './components/Navigation';
import LandingPage from './pages/LandingPage';
import { initGA, trackPageView } from './utils/analytics';
import SignupForm from './pages/SignupForm';
import MobileSignupPage from './pages/MobileSignupPage';
import MobileSigninPage from './pages/MobileSigninPage';
import AboutPage from './pages/AboutPage';
import FacultyPage from './pages/FacultyPage';
import CoursesPage from './pages/CoursesPage';
import HomePage from './pages/HomePage';
import UnitDetailPage from './pages/UnitDetailPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LoginPage from './pages/LoginPage';
import { useAuth } from './context/AuthContext';
import ProfilePage from './pages/ProfilePage';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div>Loading...</div>;
  if (!user) {
    const redirectQuery = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/login-mobile?redirect=${redirectQuery}`} replace />;
  }
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div>Loading...</div>;
  if (user) return <Navigate to="/home" replace />;
  return children;
};

// Initialize Google Analytics
initGA();

function App() {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);

  return (
    <div className="min-h-screen bg-bg-default">
      <Navigation />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/login"
          element={<Navigate to="/login-mobile" replace />}
        />
        <Route
          path="/login-mobile"
          element={(
            <PublicRoute>
              <MobileSigninPage />
            </PublicRoute>
          )}
        />
        <Route path="/register/savvy-sat" element={<Navigate to="/signup" replace />} />
          {/* Email-based signup route is preserved. Do not remove or override. */}
          <Route path="/signup" element={<SignupForm />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/signup-mobile" element={<MobileSignupPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:courseSlug" element={<ProtectedRoute><CourseDetailPage /></ProtectedRoute>} />
          <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/units/:unitSlug" element={<ProtectedRoute><UnitDetailPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      </Routes>
    </div>
  );
}

export default App;
